import cn from "classnames"

interface ITitleScreen {
  title: string
  string_id?: string
  className?: string
}

const TitleScreen = ({ title, string_id, className }: ITitleScreen) => {
  return (
    <div className={cn("w-full h-auto flex flex-row items-center justify-start gap-3 whitespace-nowrap", className)}>
      <h3 className="text-xl md:text-2xl font-semibold text-[#4C4C4C] lowercase first-letter:capitalize">
        {`${title} `}
        {string_id ? <span style={{ textTransform: "uppercase" }}>#{string_id}</span> : null}
      </h3>
      <div className="w-full h-full">
        <div className="h-1/2 border-b border-b-[#4C4C4C]"></div>
      </div>
    </div>
  )
}

export default TitleScreen
